import { type DosageData, MedicationFormMap, MedicationVolumeMap } from "@qendo/medication";
import { DataListItem } from "~/components/layout/DataListItem";
import { Nothing } from "~/components/permission/Nothing";

export type DosageProps = {
    dosage: DosageData | null | undefined;
    title: string;
};

export const Dosage = ({ dosage, title }: DosageProps) => {
    return dosage?.amount ? (
        <>
            <DataListItem title={title} data={MedicationFormMap[dosage.form]} />
            <DataListItem title="Dosage strength" data={`${dosage.amount} ${MedicationVolumeMap[dosage.volume]}`} />
        </>
    ) : (
        <Nothing />
    );
};
